import React, { Component } from 'react';

class SetOfDayTypesMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Página de Conjuntos de tipos de dia </h2>
                <p>
                    Nesta página encontra todos os conjuntos de tipos de dia. 
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar conjuntos de tipos de dia</li>
                    <li>Editar conjuntos de tipos de dia</li>
                    <li>Eliminar conjuntos de tipos de dia</li>
                    <li>Pesquisar os conjuntos de tipos de dia disponíveis</li>
                </ul>
            </div>
        );
    }
}

export default SetOfDayTypesMetadata;